import type { Ctx } from "../../types";
import { Query } from "gg-wf-scripts";
import { formatPercent } from "../../lib";

type Row = {
  substitutes_total: number | null;
  substitutes_this_month: number | null;
  schools_total: number | null;
  schools_this_month: number | null;
  jobs_ytd: number | null;
  jobs_this_month: number | null;
  total_filled_ytd: number | null;
  total_posted_ytd: number | null;
};

// Single-row platform totals from GET /api/stats/superuser. Superuser only.
export const superuser_stats: Query<Ctx> = async ({ sb }, _params) => {
  const { data, error } = await sb.functions.invoke<Row | null>(
    "api/stats/superuser",
    { method: "GET" }
  );
  if (error) console.error("superuser_stats:", error);

  const total_filled_ytd = data?.total_filled_ytd ?? null;
  const total_posted_ytd = data?.total_posted_ytd ?? null;
  const fill_rate_ytd =
    total_filled_ytd !== null &&
    total_posted_ytd !== null &&
    total_posted_ytd > 0
      ? total_filled_ytd / total_posted_ytd
      : null;

  return {
    substitutes_total: data?.substitutes_total ?? null,
    substitutes_this_month: data?.substitutes_this_month ?? null,
    schools_total: data?.schools_total ?? null,
    schools_this_month: data?.schools_this_month ?? null,
    jobs_ytd: data?.jobs_ytd ?? null,
    jobs_this_month: data?.jobs_this_month ?? null,
    fill_rate_ytd,
    f_fill_rate_ytd: formatPercent(fill_rate_ytd),
    total_filled_ytd,
    total_posted_ytd,
  };
};
